<template>
    <imports-list
        :teamId="teamId"
        importType="contact"
        newImportHref="/contacts/import/new"
        v-model:showOverview="showOverview"
    >
        <template v-slot:title>Contact Imports</template>
        <template v-slot:overview>
            <contacts-import-overview v-show="showOverview" class="mb-14"></contacts-import-overview>
        </template>
    </imports-list>
</template>

<script setup>
import ImportsList from '~/components/import/ImportsList.vue';
import ContactsImportOverview from '~/components/contacts/import/ContactsImportOverview.vue';
import { ref } from 'vue';

const teamId = Spark.state.currentTeam.id;
const showOverview = ref(true);
</script>
